// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2-xjs","rootSuccess":"CompleteLink_rootSuccess__2Dn-g","rootFailure":"CompleteLink_rootFailure__ON1Nb","isDisabled":"CompleteLink_isDisabled__WxK0x"};